document.addEventListener("DOMContentLoaded", function () {

  const showInsListing = document.querySelector(".showInsListing");

  if (showInsListing) {
    const showInsListingGlide = document.querySelector(".showInsListing__slider.glide");
    let totalSlides = 0;

    if (showInsListingGlide) {

      const siGlide = new Glide(showInsListingGlide, {
        type: 'slider',
        // autoplay: 5000,
        perView: 4.2,
        perTouch: 1,
        dragThreshold: false,
        // startAt: 0,
        // focusAt: 0,
        // keyboard: false,
        // hoverpause: true,
        // bound: true,
        gap: 38,
        breakpoints: {
          1900: {
            perView: 3.2
          },
          992: {
            perView: 2.2
          },
          768: {
            perView: 2.2,
            dragThreshold: 120,
          },
          480: {
            perView: 1
          }
        }
      });

      siGlide.mount();

    }

  }
});
